/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Browser_Extension_TitleInputs */



/**
* | output |
* | --- |
* | "Browser Extension" |
*
* @param {Help_Article_Browser_Extension_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_browser_extension_title = /** @type {((inputs?: Help_Article_Browser_Extension_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Browser_Extension_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Browser-Erweiterung")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extension de navigateur")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("浏览器扩展")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("瀏覽器擴充功能")
	if (locale === "ko") return /** @type {LocalizedString} */ ("브라우저 확장 프로그램")
	return /** @type {LocalizedString} */ ("Browser Extension")
});